<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit School Exam Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit School Exam</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input school exam name!' }]}]"
            />
          </a-form-item>
          <a-form-item
            label="Exam Type"
          >
            <a-spin :spinning="examTypesLoading">
              <a-radio-group
                v-decorator="[
                  'exam_type_id',
                  {rules: [{ required: true, message: 'Please select a type!' }], },
                ]"
              >
                <a-radio v-for="examType in examTypes" :value="examType.id" :key="examType.id" class="mr-2">
                  <span class="text-bold">{{examType.name}}</span>
                </a-radio>
              </a-radio-group>
            </a-spin>
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditSchoolExam',
  mounted: function() {
    this.getExamTypes()
    this.$eventBus.$on('openSchoolExamEditModal', this.showModal)
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      schoolExamId: null,
      examTypesLoading: false,
      examTypes: [],
    }
  },
  methods: {
    showModal: function(schoolExamId) {
      this.schoolExamId = schoolExamId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/exam/' + schoolExamId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['name', 'description', 'exam_type_id'])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    getExamTypes() {
      this.examTypesLoading = true
      this.$http.get('/api/examtype', {
        params: {
          limit: 15,
        },
      }).then(({ data }) => {
        this.examTypesLoading = false
        this.examTypes = data.data
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/exam/' + this.schoolExamId, {
                  name: values.name,
                  description: values.description,
                  exam_type_id: values.exam_type_id,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'SchoolExam details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
